import React from "react";
import { useSelector } from "react-redux";
import { Card ,Grid,Typography,CardContent,Divider} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Backlink from "../../self-help/backlink";
import { makeStyles } from "@material-ui/core/styles";
import {Skeleton} from '@material-ui/lab';
const useStyles = makeStyles(theme=>({
    heading:{
        color : theme.palette.ePrimary.base
    },
    subHeading : {
        fontWeight : "bold"
    }
}))

export default function E_TermsAndPolicy(){
    const classes = useStyles()
    const {t:labels, ready: labelReady} = useTranslation("label-E_NESCO_TERMS") ;
    const {t:content, ready: contentReady} = useTranslation("content-E_NESCO_TERMS_POLICY")
    const browserName = useSelector((store) => store?.browserDetect?.browserName);

    return(
    <>
    <Card style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}>
        <CardContent>
            <Grid container direction="row" spacing={1}>
                <Grid item md={4} sm={2}>
                <Backlink/>
                </Grid>
                <Grid item md={4} sm={8}>
                {
                    labelReady ?
                <Typography variant="h6" className={classes.heading}>
                    {labels("E_TERMS_HEADER")}
                </Typography>
                :  <Skeleton/>
                }
                </Grid>
                <Divider/>
            </Grid>
            <Grid container>
            {
                labelReady && contentReady ?
                <>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_TERMS_SERVICES")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_TERMS_SERVICES").answer
                    }}
                    ></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_INFORMATION_USE")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_INFORMATION").answer
                    }}></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_LOG_DATA")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_LOG_DATA").answer
                    }}></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_OFFICE_STORAGE")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_OFFICE_STORAGE").answer
                    }}></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_SECURITY")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_SECURITY").answer
                    }}></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_LINKS_SITES")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_LINKS_SITES").answer
                    }}></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_CHILDREN_POLICY")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_CHILDREN_POLICY").answer
                    }}></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_PRIVATE_POLICY")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_PRIVATE_POLICY").answer
                    }}></Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" className={classes.subHeading}>
                        {labels("E_CONTACT_US")}
                    </Typography>
                    <Typography  
                    align="left"
                    variant="subtitle1" 
                    dangerouslySetInnerHTML={{
                    __html: content("E_CONTACT_US").answer
                    }}></Typography>
                </Grid>
                </>
                : <Skeleton />
            }
            </Grid>
        </CardContent>
    </Card>
    </>

    )
}